import React from 'react';
import NavBar from './NavBar';

function Header() {
    return (
        <header>
            <NavBar />
        </header>
    );
}

export default Header;
